import Image from "next/image";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
// CountriesWithFlags.js
// import countriesData from "."
import { allCountries } from "country-flag-icons";

import {
  editProfile,
  fetchUserProfile,
  getBankList,
  getCountryList,
  getNonNigerianBanksList,
  updatebBank,
  updateSocial,
} from "../../../api-client/profile";

// import Button from "../../elements/button";
import { DashCard } from "../../elements/card";
import { EditInput } from "../../elements/input";
import CountryModalBank, {
  AddBankModal,
  CountryModal,
  NonNigerianBankModal,
} from "../../widgets/modals/select-modal";
import VendorBadges from "../../widgets/vendor-badge";
import Profile from "./Profile";
import ProfileWidgets from "./Profile";
import Profiles from "./Profile";
import PasswordResetWidget from "../../widgets/password-reset";
import Security from "./Security";
import ProfileSidebar from "../../elements/profile-sidebar/ProfileSidebars";
import Sidebar from "../../elements/profile-sidebar";
import BankSidebar from "../../elements/profile-sidebar/Bank_Sidebar";
import SocialSideBar from "../../elements/profile-sidebar/Social_Sidebar";
import CountriesWithFlags from "./Country";
import CountryDropdown from "./Country";
import CountryModalBanks from "./Test";
import Subscription from "../../../pages/dashboard/subscription";
import Link from "next/link";
import Kyc from "../../elements/profile-sidebar/kyc";
const DropdownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6331_26555)">
      <path
        d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_6331_26555">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Button = ({ className, onClick, label }) => (
  <button
    className={`flex items-center justify-between ${className}`}
    onClick={onClick}
  >
    {label}
    <DropdownIcon />
  </button>
);
const ProfileWidget = () => {
  const [socialUpdateLoading, setUpdateSocialLoading] = useState(false);
  const [loading, setLoading] = useState();
  const [updateBankLoading, setUpdateBankLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [cookie, setCookie] = useCookies();
  const [_banks, setBanks] = useState([]);
  const [_mobileMoney, setMobileMoney] = useState([]);
  const [profileEditMode, setProfileEditMode] = useState(false);

  const { data: _countryList, isCountryLoading } = useQuery(
    ["country-list"],
    getCountryList
  );

  const getBank = async () => {
    try {
      const res = await getBankList();
      setBanks(res.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const getNonNigerianBanks = async () => {
    try {
      const res = await getNonNigerianBanksList();
      setMobileMoney(res.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const [addBankModal, setAddBankModal] = useState(false);
  const [selectCountryModal, setSelectCountryModal] = useState(false);
  const [nonNigerianBankModal, setNonNigerianBankModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");

  const [countryValue, setCountryValue] = useState("");
  // input State
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");
  const [country, setCountry] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [twitter, setTwitter] = useState("");
  const [instagram, setInstagram] = useState("");
  const [tiktok, setTiktok] = useState("");
  const [facebook, setFacebook] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [nonNgBankAccountName, setNonNgBankAccountName] = useState("");

  const [firstNameFocus, setFirstNameFocus] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);
  const [phoneFocus, setPhoneFocus] = useState(false);
  const [phone2Focus, setPhone2Focus] = useState(false);

  const [twitterFocus, setTwitterFocus] = useState(false);
  const [instagramFocus, setInstagramFocus] = useState(false);
  const [tiktokFocus, setTiktokFocus] = useState(false);
  const [facebookFocus, setFacebookFocus] = useState(false);

  const [firstNameUpdateBtn, setfirstNameUpdateBtn] = useState(false);
  const [lastNameUpdateBtn, setlastNameUpdateBtn] = useState(false);
  const [phoneUpdateBtn, setphoneUpdateBtn] = useState(false);
  const [phone2UpdateBtn, setphone2UpdateBtn] = useState(false);
  const [countryUpdateBtn, setcountryUpdateBtn] = useState(false);
  const [passwordUpdateBtn, setpasswordUpdateBtn] = useState(false);
  const [accountNumberUpdateBtn, setaccountNumberUpdateBtn] = useState(false);
  const [twitterUpdateBtn, settwitterUpdateBtn] = useState(false);
  const [instagramUpdateBtn, setinstagramUpdateBtn] = useState(false);
  const [facebookUpdateBtn, setFacebookUpdateBtn] = useState(false);
  const [tiktokUpdateBtn, setTiktokUpdateBtn] = useState(false);

  const level = useMemo(() => cookie?.user?.userData[0]?.level, [cookie]);
  const banks = useMemo(
    () =>
      _banks.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_banks]
  );

  const countryList = useMemo(
    () =>
      _countryList?.data?.data.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_countryList]
  );

  const mobileMoney = useMemo(
    () =>
      _mobileMoney?.map((val) => ({
        label: val.bankName,
        value: val.bankCode,
      })),
    [_mobileMoney]
  );

  // Create Reference for All fields
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const phoneRef = useRef();
  const phone2Ref = useRef();
  const passwordRef = useRef();
  const accountNumberRef = useRef();
  const twitterRef = useRef();
  const instagramRef = useRef();
  const emailRef = useRef();
  const countryRef = useRef();
  const tiktokRef = useRef();
  const facebookRef = useRef();

  // Get User
  const getUser = async () => {
    setLoading(true);
    try {
      const res = await fetchUserProfile();
      const { user, profile } = res?.data?.data;
      setFirstName(user?.firstName);
      setLastName(user?.lastName);
      setPhone(user?.phone);
      setPhone2(user?.phone2);
      setEmail(user?.email);
      setCountry(user?.country);
      setAccountNumber(profile?.accountNumber);
      setBankName(profile?.bankName);
      setAccountName(profile?.accountName);
      setTwitter(profile?.twitter);
      setInstagram(profile?.instagram);
      setFacebook(profile?.facebook);
      setTiktok(profile?.tiktok);

      setLoading(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      // reject(error);
    }
  };

  const updateSocialMedia = async () => {
    setUpdateSocialLoading(true);

    const data = {
      twitter,
      instagram,
      tiktok,
      facebook,
    };

    try {
      const res = await updateSocial(data);
      setUpdateSocialLoading(false);
      toast.success(res.data.message);
      setTwitterFocus(false);
      setInstagramFocus(false);
      setTiktokFocus(false);
      setInstagramFocus(false);
    } catch (error) {
      setUpdateSocialLoading(false);
      toast.error("Something went wrong! Please try Again");
    }
  };

  // Update Profile Details
  const updateProfile = async () => {
    setLoading(true);

    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      country: selectedCountry,
    };

    try {
      const res = await editProfile(data);
      setLoading(false);
      setFirstNameFocus(false);
      setLastNameFocus(false);
      setPhoneFocus(false);
      setPhone2Focus(false);
      setSelectCountryModal(false);

      setFirstName(res?.data?.data?.firstName);
      setLastName(res?.data?.data?.lastName);
      setPhone(res?.data?.data?.phone);
      setPhone2(res?.data?.data?.phone2);
      setCountry(res?.data?.data?.country);

      toast.success(res.data.message);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response.data.message || "something went wrong, please try again"
      );
    }
  };

  // Update Bank Details
  const updateBank = useCallback(async () => {
    setUpdateBankLoading(true);
    const data = {
      bankName: selectedBank,
      bankCode,
      accountNumber: accountNo?.replace(/[^a-zA-Z0-9 ]/g, ""),
      accountName: nonNgBankAccountName,
    };

    try {
      const res = await updatebBank(data);
      toast.success(res.data.message);
      setAddBankModal(false);
      setNonNigerianBankModal(false);
      setUpdateBankLoading(false);

      setAccountName(res?.data?.data?.accountName);
      setAccountNumber(res?.data?.data.accountNumber);
      setBankName(res?.data?.data?.bankName);
    } catch (error) {
      setLoading(false);
      toast.error("Invalid Bank Details!, Please try Again!");
      setUpdateBankLoading(false);
    }
  }, [selectedBank, bankCode, accountNo, nonNgBankAccountName]);

  useEffect(() => {
    getUser();
  }, []);
  const [activeTab, setActiveTab] = useState("personal_information");
  const [colorIndex, setColorIndex] = useState(0);

  const colors = ["bg-affad", "bg-heroLgB", "bg-heroLgC"];

  return (
    <>
      {addBankModal && (
        <AddBankModal
          setAddBankModal={setAddBankModal}
          options={banks}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {nonNigerianBankModal && (
        <NonNigerianBankModal
          setNonNigerianBankModal={setNonNigerianBankModal}
          options={mobileMoney}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          accountName={nonNgBankAccountName}
          setAccountName={setNonNgBankAccountName}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {selectCountryModal && (
        <CountryModal
          loading={loading}
          setSelectCountryModal={setSelectCountryModal}
          options={countryList}
          selectedInput={selectedCountry}
          setSelectedInput={setSelectedCountry}
          updateProfile={updateProfile}
          value={countryValue}
          setValue={setCountryValue}
        />
      )}

      <div className="flex flex-col w-full  ">
        <div className="flex lg:space-x-4 space-x-2 py-2 mb-4 text-[12px] leading-[16.8px]  mt-2 p-0 lg:p-4 bg-white  rounded  overflow-x-auto ">
          <button
            onClick={() => setActiveTab("personal_information")}
            className={`lg:px-6 px-3 text-[10px] lg:text-[12px] leading-[16.8px]   lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "personal_information"
                ? "bg-[#205363] text-white "
                : " text-[#205363] font-bold"
            }`}
          >
            Personal Information
          </button>
          <button
            onClick={() => setActiveTab("banking_details")}
            className={`lg:px-6 px-3 text-[10px] lg:text-[12px] leading-[16.8px]  lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "banking_details"
                ? "bg-[#205363] text-white "
                : " text-[#205363] font-bold"
            }`}
          >
            Banking Details
          </button>
          {/* <button
            onClick={() => setActiveTab("security")}
            className={`lg:px-6 px-3 text-[10px] lg:text-[12px] leading-[16.8px]  lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "security"
                ? "bg-[#205363] text-white "
                : " text-[#205363] font-bold "
            }`}
          >
            Security
          </button> */}
          <button
            onClick={() => setActiveTab("social_handle")}
            className={`lg:px-6 px-3 text-[10px]  lg:text-[12px] leading-[16.8px]  lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "social_handle"
                ? "bg-[#205363] text-white "
                : " text-[#205363]  font-bold"
            }`}
          >
            Social Handle
          </button>
          {/* <button
            onClick={() => setActiveTab("subscription")}
            className={`lg:px-6 px-3 text-[10px]  lg:text-[12px] leading-[16.8px]  lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "subscription"
                ? "bg-[#205363] text-white "
                : " text-[#205363]  font-bold"
            }`}
          >
            Subscription
          </button> */}
          {/* <button
            onClick={() => setActiveTab("kyc")}
            className={`lg:px-6 px-3 text-[10px]  lg:text-[12px] leading-[16.8px]  lg:py-4 py-2 lg:rounded-2xl rounded-lg ${
              activeTab === "kyc"
                ? "bg-[#205363] text-white "
                : " text-[#205363]  font-bold"
            }`}
          >
            KYC
          </button> */}
        </div>

        <div className="flex items-center justify-start mb-3 ">
          <div className="relative p-3">
            <div className=" ">
              <VendorBadges rank={level} className="px-4" />
            </div>
          </div>
          <h3 className="text-[1.7rem] font-bold  text-[#205363]">
            {firstName} {lastName}
          </h3>
        </div>
        <div
          className={` flex  lg:flex-row flex-col relative rounded-[18px] bg-no-repeat bg-cover  pb-8 w-full border-2  bg-red-800 text-white   px-6  pt-6 items-center`}
        >
          <p className=" ">
            For Nigerian Users, Do not Use MoniePoint, Opay, Kuda or PalmPay
            Bank, as we don&apos;t process payout to these banks
          </p>
        </div>
        <div className="w-full lg:h-screen flex-col flex overflow-hidden ">
          {activeTab === "personal_information" && (
            <div className=" mt-10 py-10  lg:px-10 px-5 rounded-[20px] border-[1px]">
              <div className="mt-6">
                <div className="flex justify-between w-full items-center ">
                  <p className="font-[600] text-[#205363] leading-[22.4px] text-[16px] ">
                    Personal Information
                  </p>
                  <Sidebar />
                </div>
                <div className="flex flex-wrap  mt-10   items-center mx-2 ">
                  <section className="flex  flex-col lg:w-1/3 md:w-1/2 w-full justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                        Full Name
                      </h4>

                      <p className="font-[500] leading-[19.6px] lg:text-[14px] text-[12px] text-[#282828]">
                        {firstName} {lastName}
                      </p>
                    </div>
                  </section>

                  <section className="flex items-center lg:w-1/3 md:w-1/2 w-full  justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                        Email
                      </h4>
                      <h3 className="font-[500] leading-[19.6px] lg:text-[14px] text-[12px] text-[#282828]">
                        {email}
                      </h3>
                    </div>
                    <div></div>
                  </section>
                  <section className="flex items-center lg:w-1/3 md:w-1/2 w-full  justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                        Phone Number (Primary)
                      </h4>

                      <p className="text-[12px] lg:text-[14px] text-[#282828]">
                        {phone}
                      </p>
                    </div>
                  </section>

                  <section className="flex items-center lg:w-1/3 md:w-1/2 w-full  justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                        Phone Number (Secondary)
                      </h4>
                      <p className="font-[500] leading-[19.6px] text-[12px] lg:text-[14px] text-[#282828]">
                        {phone2}
                      </p>
                    </div>
                  </section>
                  <section className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                    <div>
                      <h4 className="text-neutral-light-50 mb-2">Country</h4>
                      <p className="font-[500] leading-[19.6px] text-[12px] lg:text-[14px] text-[#282828]">
                        {country}
                      </p>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          )}
          {activeTab === "banking_details" && (
            <div className="">
              <BankSidebar />
            </div>
          )}
          {activeTab === "security" && (
            <div className="mt-6">
              <p className="font-[600] text-[#205363] leading-[22.4px] text-[20px] my-10">
                Security
              </p>

              <Security />
            </div>
          )}
          {activeTab === "social_handle" && (
            <div className=" mt-10 py-10   lg:px-10 px-4 rounded-[20px] border-[1px]">
              <div className="mt-6 ">
                <div className="flex justify-between w-full  lg:px-0 px-2 ">
                  <p className="font-[600] text-[#205363] leading-[22.4px] text-[20px] my-10">
                    Social Handle
                  </p>
                  <SocialSideBar />
                </div>
                <div className="flex flex-wrap   bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 mt-10  lg:items-center mx-2">
                  <section className="lg:px-0 px-2 flex lg:w-1/2 md:w-1/2 w-full items-center justify-between my-5 ">
                    <div>
                      <h4 className=" font-[500] text-[#828282] mb-2 text-[12px]">
                        Twitter Handle
                      </h4>
                      <p className="lg:text-[18px] text-[12px] font-[500] text-[#282828]">
                        {twitter}
                      </p>
                      {/* <EditInput
                    value={twitter}
                    onChange={(e) => setTwitter(e.target.value)}
                    placeholder="Edit Twitter Handle"
                    inputRef={twitterRef}
                    onFocus={() => setTwitterFocus(true)}
                  /> */}
                    </div>
                    {/* <div className="w-32">
                  <Button
                    className="w-32 py-[13px] bg-primary-p300 text-light"
                    onClick={() =>
                      twitterFocus
                        ? updateSocialMedia()
                        : twitterRef.current.focus()
                    }
                    label={`${twitterFocus ? "Update" : "Edit"}`}
                    loading={loading}
                  />
                </div> */}
                  </section>
                  <section className="lg:px-0 px-2 flex lg:w-1/2 md:w-1/2 w-full items-center justify-between my-5">
                    <div>
                      <h4 className=" font-[500] text-[#828282] mb-2 text-[12px]">
                        Instagram handle
                      </h4>
                      <p className="lg:text-[18px] text-[12px] font-[500] text-[#282828]">
                        {instagram}
                      </p>
                      {/* <EditInput
                    value={instagram}
                    onChange={(e) => setInstagram(e.target.value)}
                    placeholder="Edit Instagram Handle"
                    inputRef={instagramRef}
                    onFocus={() => setInstagramFocus(true)}
                  /> */}
                    </div>
                    {/* <div className="w-32">
                  <Button
                    className="w-32 py-[13px] bg-primary-p300 text-light"
                    onClick={() =>
                      instagramFocus
                        ? updateSocialMedia()
                        : instagramRef.current.focus()
                    }
                    label={`${instagramFocus ? "Update" : "Edit"}`}
                  />
                </div> */}
                  </section>
                  <section className="lg:px-0 px-2 flex lg:w-1/2 md:w-1/2 w-full items-center justify-between my-5">
                    <div>
                      <h4 className=" font-[500] text-[#828282] mb-2 text-[12px]">
                        TikTok handle
                      </h4>
                      <p className="lg:text-[18px] text-[12px] font-[500] text-[#282828]">
                        {tiktok}
                      </p>
                      {/* <EditInput
                    value={tiktok}
                    onChange={(e) => setTiktok(e.target.value)}
                    placeholder="Edit Tiktok Handle"
                    inputRef={tiktokRef}
                    onFocus={() => setTiktokFocus(true)}
                  /> */}
                    </div>
                    <div className="w-32">
                      {/* <Button
                    className="w-32 py-[13px] bg-primary-p300 text-light"
                    onClick={() =>
                      tiktokFocus
                        ? updateSocialMedia()
                        : tiktokRef.current.focus()
                    }
                    label={`${tiktokFocus ? "Update" : "Edit"}`}
                  /> */}
                    </div>
                  </section>
                  <section className="lg:px-0 px-2 flex lg:w-1/2 md:w-1/2 w-full items-center justify-between my-5">
                    <div>
                      <h4 className=" font-[500] text-[#828282] mb-2 text-[12px]">
                        Facebook Handle
                      </h4>
                      <p className="lg:text-[18px] text-[12px] font-[500] text-[#282828]">
                        {facebook}
                      </p>
                      {/* <EditInput
                    value={facebook}
                    onChange={(e) => setFacebook(e.target.value)}
                    placeholder="Edit Facebook Handle"
                    inputRef={facebookRef}
                    onFocus={() => setFacebookFocus(true)}
                  /> */}
                    </div>
                    <div className="w-32">
                      {/* <Button
                    className="w-32 py-[13px] bg-primary-p300 text-light"
                    onClick={() =>
                      facebookFocus
                        ? updateSocialMedia()
                        : facebookRef.current.focus()
                    }
                    label={`${facebookFocus ? "Update" : "Edit"}`}
                  /> */}
                    </div>
                  </section>
                </div>
              </div>
            </div>
          )}
          {/* {activeTab === "kyc" && (
            <div id="kyc">
            
              <div className=" mt-10 py-10  lg:px-10 px-3 rounded-[20px] border-[1px]">
                <div className="mt-6">
                  <div className="flex justify-between w-full  mb-8 ">
                    <div>
                      <p className="font-[600] text-[#282828] leading-[14px] lg:leading-[21px] text-[14px] lg:text-[18px]">
                        Identification Document
                      </p>
                      <p className="font-[400] text-[#828282] my-2 leading-[13px] lg:leading-[26px] text-[10px] lg:text-[14px]">
                        Upload a valid identification document
                      </p>
                    </div>
                 <Kyc/>
                  </div>
                </div>
              </div>
            </div>
          )} */}
          {/* {activeTab === "subscription" && (
<div>
 
  <div className=" mt-10 py-10  lg:px-10 px-3 rounded-[20px] border-[1px]">
              <div className="mt-6">
                <div className="flex justify-between w-full  mb-8 ">
                  <div>
                  <p className="font-[600] text-[#282828] leading-[14px] lg:leading-[21px] text-[14px] lg:text-[18px]">
                  Manage your  Plan Today 
                  </p>
                  <p className="font-[400] text-[#828282] my-2 leading-[13px] lg:leading-[26px] text-[10px] lg:text-[14px]">
                  Upgrade and manage your subscription plans anytime you want
                  </p>
                  </div>
                  <Link href="/dashboard/subscription">
                  <button
                 
                  className="lg:px-10  w-[198px] py-5 whitespace-nowrap font-[600] border-[1px] mt-2 h-[46px] text-[#205363] leading-[14px] text-[13px]  rounded-xl border-[#205363]"
                >
                 Renew Subscription
                </button>
                  </Link>
                </div>
                <hr/>
                <div className="flex flex-wrap  mt-10  items-center mx-2 my-10 pt-4">
                  <section className="flex  flex-col lg:w-1/4 md:w-1/2 w-full justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                       Plan
                      </h4>
                      <p className="font-[600] text-[#282828] leading-[21px] text-[18px]">
                       Pro Plan
                      </p>
                    </div>
                  </section>

                  <section className="flex items-center lg:w-1/4 md:w-1/2 w-full  justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                      Cost
                      </h4>
                      <p className="font-[600] text-[#282828] leading-[21px] text-[18px]">
                     $9
                      </p>
                    </div>
                    <div></div>
                  </section>
                  <section className="flex items-center lg:w-1/4 md:w-1/2 w-full  justify-between mb-9">
                    <div>
                      <h4 className="text-neutral-light-50 text-[14px] leading-[18.2px] mb-2">
                       Renewal Date
                      </h4>
                      <p className="font-[600] text-[#282828] leading-[21px] text-[18px]">

                   
                      13th Dec  2025
                      </p>
                    </div>
                  </section>

                </div>
              </div>
            </div>
</div>
          )} */}
        </div>
        {/* <Sidebar /> */}
      </div>
    </>
  );
};

export default ProfileWidget;

{
  /* <div className="m-auto mx-8">
        <Profiles/>
        <div className="flex items-center justify-start mb-9">
          <div className="relative p-8">
            <div>
              <VendorBadges rank={level} />
            </div>
          </div>
          <h3 className="text-[1.5rem] font-medium">
            {firstName} {lastName}
          </h3>
        </div>

        <DashCard className="mt-6">
          <section className="flex sitems-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">First Name</h4>
              <EditInput
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Edit First Name"
                inputRef={firstNameRef}
                onFocus={() => setFirstNameFocus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={async () =>
                  firstNameFocus
                    ? await updateProfile()
                    : firstNameRef.current.focus()
                }
                label={firstNameFocus ? 'Update' : 'Edit'}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Last Name</h4>
              <EditInput
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Edit Last Name"
                inputRef={lastNameRef}
                onFocus={() => setLastNameFocus(true)}
                // onBlur={() => setLastNameFocus(false)}
              />
            </div>

            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={async () =>
                  lastNameFocus
                    ? await updateProfile()
                    : lastNameRef.current.focus()
                }
                label={lastNameFocus ? 'Update' : 'Edit'}
              />
            </div>
          </section>

          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Email</h4>
              <h3>{email}</h3>
            </div>
            <div></div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">
                Phone Number (Primary)
              </h4>
              <EditInput
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Edit Phone Number"
                inputRef={phoneRef}
                onFocus={() => setPhoneFocus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={async () => {
                  phoneFocus ? await updateProfile() : phoneRef.current.focus();
                }}
                label={phoneFocus ? 'Update' : 'Edit'}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">
                Phone Number (Secondary)
              </h4>

              <EditInput
                value={phone2}
                onChange={(e) => setPhone2(e.target.value)}
                placeholder="Edit Phone Number 2"
                inputRef={phone2Ref}
                onFocus={() => setPhone2Focus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={async () => {
                  phone2Focus
                    ? await updateProfile()
                    : phone2Ref.current.focus();
                }}
                label={phone2Focus ? 'Update' : 'Edit'}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Country</h4>

              <EditInput
                value={country}
                placeholder="Select Country"
                inputRef={countryRef}
                disabled={true}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={() => setSelectCountryModal(true)}
                label="Edit"
              />
            </div>
          </section>
        </DashCard>
        <DashCard className="mt-6">
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Account Name</h4>
              <h3>{accountName}</h3>
            </div>
            <div></div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Account Number</h4>
              <EditInput
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                placeholder="Edit Account Number"
                inputRef={accountNumberRef}
              />
            </div>
            <div></div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Bank Name</h4>
              <h3>{bankName}</h3>
            </div>
            <div>
              <button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={async () => {
                  if (country === '') {
                    return toast.error(
                      'Please set your country before you can proceed',
                    );
                  } else if (!['Nigeria', 'Ghana'].includes(country)) {
                    console.log('Non Nigerian Country');
                    await getNonNigerianBanks();
                    setNonNigerianBankModal(true);
                  } else {
                    await getBank();
                    setAddBankModal(true);
                  }
                }}
              >
                Edit
              </button>
            </div>
          </section>
        </DashCard>
        <DashCard className="mt-6">
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Twitter Handle</h4>
              <EditInput
                value={twitter}
                onChange={(e) => setTwitter(e.target.value)}
                placeholder="Edit Twitter Handle"
                inputRef={twitterRef}
                onFocus={() => setTwitterFocus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={() =>
                  twitterFocus
                    ? updateSocialMedia()
                    : twitterRef.current.focus()
                }
                label={`${twitterFocus ? 'Update' : 'Edit'}`}
                loading={loading}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Instagram handle</h4>
              <EditInput
                value={instagram}
                onChange={(e) => setInstagram(e.target.value)}
                placeholder="Edit Instagram Handle"
                inputRef={instagramRef}
                onFocus={() => setInstagramFocus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={() =>
                  instagramFocus
                    ? updateSocialMedia()
                    : instagramRef.current.focus()
                }
                label={`${instagramFocus ? 'Update' : 'Edit'}`}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">TikTok handle</h4>
              <EditInput
                value={tiktok}
                onChange={(e) => setTiktok(e.target.value)}
                placeholder="Edit Tiktok Handle"
                inputRef={tiktokRef}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={() =>
                  tiktokFocus ? updateSocialMedia() : tiktokRef.current.focus()
                }
                label={`${tiktokFocus ? 'Update' : 'Edit'}`}
              />
            </div>
          </section>
          <section className="flex items-center justify-between mb-9">
            <div>
              <h4 className="text-neutral-light-50 mb-2">Facebook Handle</h4>
              <EditInput
                value={facebook}
                onChange={(e) => setFacebook(e.target.value)}
                placeholder="Edit Facebook Handle"
                inputRef={facebookRef}
                onFocus={() => setFacebookFocus(true)}
              />
            </div>
            <div className="w-32">
              <Button
                className="w-32 py-[13px] bg-primary-p300 text-light"
                onClick={() =>
                  facebookFocus
                    ? updateSocialMedia()
                    : facebookRef.current.focus()
                }
                label={`${facebookFocus ? 'Update' : 'Edit'}`}
              />
            </div>
          </section>
        </DashCard>
      </div> */
}
